import { Component, OnInit } from '@angular/core';

import { ConfirmationService, LazyLoadEvent, MenuItem, MessageService } from 'primeng/api';
import * as FileSaver from 'file-saver';

import { ConsultaService } from '../../service/consulta.service';
import { OcorrenciaService } from "../../service/ocorrencia.service";
import { FiltroInterface, InterfaceAms, InterfaceAmsDetalhes, InterfaceArquivo } from '../../domain/interface';
import { ResponseFileDTO } from '../../domain/file';
import { DatePipe } from '@angular/common'
import { OcorrenciaHistorico, OcorrenciaHistoricoDTO } from "../../domain/OcorrenciaHistorico";
import { MsalService } from '@azure/msal-angular';
import { AppContextService } from 'src/app/core/service/app-context.service';

@Component({
  templateUrl: './new-consulta.component.html',
  providers: [MessageService, ConfirmationService],
  styleUrls: ['../../../../assets/demo/badges.scss', './new-consulta.component.css'],
  styles: [`
    :host ::ng-deep .p-frozen-column {
      font-weight: bold;
    }

    :host ::ng-deep .p-datatable-frozen-tbody {
      font-weight: bold;
    }

    :host ::ng-deep .p-progressbar {
      height: .5rem;
    }
  `]
})

export class NovaConsultaComponent implements OnInit {

  tipoDeMovimento: any[];

  situcacaoDeProcessamento: any[];

  interfaceDialog: boolean = false;
  email: string;
  interfaceRegularizacaoOcorrenciaHistorico: boolean = false;
  interfaceTratativaOcorrencia: boolean = false;
  interfaceErroDialog: boolean = false;
  interfaceDetalhesDialog: boolean = false;
  interfaceOcorrenciaNaocadastrada: boolean = false;
  interfaceErroDetalhesDialog: boolean = false;

  submitted: boolean = false;

  cols: any[];

  colsErros: any[];

  rowsPerPageOptions = [5, 10, 20];

  items: MenuItem[];

  itemArquivo: MenuItem[];

  listaInterfaceArquivos: InterfaceArquivo[];

  listaOcorrenciaDb2Grid: any = new Array();

  listaInterfaceAms: InterfaceAms[] = new Array();

  situacaoRegularizacao: any = new Array();
  listaInterfaceAmsDetalhes: InterfaceAmsDetalhes[] = new Array();

  interfaceListaSelecionada: InterfaceArquivo = {};

  idInterfaceSelecionadaDetalhes: number = null;

  interfaceAmsSelecionada: InterfaceAms = null;

  filtroInterface: FiltroInterface;

  situacaoHistorico: OcorrenciaHistorico;

  totalRegistrosGridPrincipal: number = 0;

  totalRegistrosGridDetalhes: number = 0;

  qtdLinhasGridPrincipal: number = 10;

  qtdLinhasGridDetalhes: number = 10;

  isOrdenadoPorData: boolean = true;

  icon: string = "pi pi-sort-amount-up";

  first = 0;

  firstDetalhes = 0;

  nomeArquivoSelecionado?: string;

  idOcorrenciaSelecionda?: number;
  idInterfaceAmsSelecionada?: number;

  responseFileDTO: ResponseFileDTO
  listaOcorrencia: any = new Array();
  interfaceListaOcorrenciaCadastradaDB2: boolean = false;
  listaHistoricoGrid: any = new Array();

  ocorrenciaHistoricoDTO: OcorrenciaHistoricoDTO;

  dataGeracaoOrdenacao: number;

  constructor(
    private consultaService: ConsultaService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private datePipe: DatePipe,
    private regularizacaoOcorrenciaService: OcorrenciaService,
    private msalService: MsalService,
    private appContext: AppContextService) {
  }

  ngOnInit() {

    this.appContext.setOrigem('NOVO_SAM');

    this.validaAcesso();

    this.dataGeracaoOrdenacao = -1;

    let dataTermino: Date = new Date();
    let dataInicio: Date = new Date();
    dataInicio.setDate(dataTermino.getDate() - 5);

    this.ocorrenciaHistoricoDTO = <OcorrenciaHistoricoDTO>({
      idOcorrencia: null,
      decricaoErro: null,
      situacao: null
    })

    this.filtroInterface = <FiltroInterface>({
      interfaceArquivo: null,
      tipoMovimento: null,
      situacaoProcessamento: 0,
      dataInicio: dataInicio,
      dataTermino: dataTermino,
    });

    this.situacaoHistorico = <OcorrenciaHistorico>({
      idOcorrencia: 0,
      decricaoErro: '',
      situacao: '0',
    });

    this.buscarListaInterfacesArquivo(true);
    this.buscarInterfacesAms(true);

    this.tipoDeMovimento = [
      { nome: 'Nova Solução Financeira -> P1', code: 'S' },
      { nome: 'P1 -> Nova Solução Financeira', code: 'E' },
    ];

    this.situacaoRegularizacao = [
      { nome: 'Selecione', code: '0' },
      { nome: 'Pendente', code: '1' },
      { nome: 'Em Análise ', code: '2' },
      { nome: 'Regularizado', code: '3' },
    ];

    this.situcacaoDeProcessamento = [
      { nome: 'Todos', code: 'T' },
      { nome: 'Pendentes de processamento', code: 'P' },
      { nome: 'Processados com erro', code: 'E' },
      { nome: 'Processados sem erro', code: 'S' },
    ];

    this.items = [
      {
        label: 'DOWNLOAD ARQUIVO', icon: 'pi pi-download', command: () => this.downloadArquivo()
      },

      { separator: true },
      {
        label: 'RELATÓRIO DETALHADO', icon: 'pi pi-server', command: () => this.gerarRelatorioDetalhado()

      },
      { separator: true },

      {
        label: 'RELATÓRIO CONSOLIDADO', icon: 'pi pi-file-excel', command: () => this.gerarExcelConsolidado()
      },

      { separator: true },
      {
        visible: this.validaAcesso() === true,
        label: 'REGULARIZAÇÃO DE OCORRENCIA',
        icon: 'pi pi-search',
        command: () => this.abrirRegularizacaoOcorrencia(),
      },
    ];

    this.itemArquivo = [
      {
        label: 'DOWNLOAD ARQUIVO', icon: 'pi pi-download', command: () => this.downloadArquivo()
      },
    ];

  }

  fecharInterfaceDetalhesDialog() {
    this.interfaceDetalhesDialog = false;
    this.submitted = false;
  }

  abrirInterfaceErroDetalhesDialog(_interfaceAms: InterfaceAms) {
    this.interfaceAmsSelecionada = null;
    if (_interfaceAms !== null && _interfaceAms.qtdeErros < 1) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Aviso',
        detail: 'Não há detalhes para serem exibidos na tela',
        life: 3000
      });
      this.submitted = false;
      return;
    }

    if (_interfaceAms !== null) {
      this.interfaceAmsSelecionada = _interfaceAms;
      this.buscarDetalheInterfaceAms(this.interfaceAmsSelecionada.id);
    }
    this.submitted = false;
  }

  fecharInterfaceErroDetalhesDialog() {
    this.interfaceErroDetalhesDialog = false;
    this.submitted = false;
  }

  async buscarInterfacesAms(reset: boolean) {
    this.submitted = true;
    this.listaInterfaceAms = new Array();
    this.totalRegistrosGridPrincipal = 0;

    if (this.filtroInterface.dataTermino !== null && this.filtroInterface.dataTermino !== undefined) {
      if (this.filtroInterface.dataInicio == null || this.filtroInterface.dataInicio == undefined) {
        this.messageService.add({ severity: 'warn', summary: 'Aviso', detail: 'Informar a Data Inicio do período', life: 3000 });
        this.submitted = false;
        return;
      }
    }

    if (this.filtroInterface.dataTermino !== null && this.filtroInterface.dataTermino !== undefined) {
      if (this.filtroInterface.dataInicio !== null || this.filtroInterface.dataInicio !== undefined) {
        if (this.filtroInterface.dataInicio.getTime() > this.filtroInterface.dataTermino.getTime()) {
          console.log(`Log filtro data Inicio : ${this.filtroInterface.dataInicio.getTime()}, filtro data termino : ${this.filtroInterface.dataTermino.getTime()}`);
          this.messageService.add({ severity: 'error', summary: 'Erro', detail: 'Verificar Datas informadas no filtro', life: 3000 });
          this.submitted = false;
          return;
        }
      }
    }

    if (reset) {
      this.first = 0;
    }

    if (this.filtroInterface != null) {
      await this.consultaService.buscaInterfaceAmsFiltro(this.filtroInterface).then(data => {
        this.listaInterfaceAms = data.content;
        if (this.dataGeracaoOrdenacao === 1) {
          this.ordenarListaInterfaceAms(false);
        }
        this.totalRegistrosGridPrincipal = data.totalElements;

      }, (err) => {
        console.log(err);
        this.submitted = false;
        this.messageService.add({ severity: 'error', summary: 'Erro', detail: 'Erro Consulta da interface', life: 3000 });
      });
      this.submitted = false;
    }
    this.submitted = false;
  }

  ordenarListaInterfaceAms(resetOrder: boolean) {
    if (this.listaInterfaceAms != null && this.listaInterfaceAms.length > 1) {
      if (this.isOrdenadoPorData) {
        this.icon = "pi pi-sort-amount-up";
        this.listaInterfaceAms.sort((a, b) => {
          return a.id > b.id ? -1 : 1;
        });
      } else {
        this.icon = "pi pi-sort-amount-down";
        this.listaInterfaceAms.sort((a, b) => {
          return a.id < b.id ? -1 : 1;
        });
      }
    }
    if (resetOrder) {
      this.isOrdenadoPorData = !this.isOrdenadoPorData;
    }

  }

  buscarInterfacesAmsPorPagina(event: LazyLoadEvent) {
    if (this.qtdLinhasGridPrincipal !== event.rows) {
      this.qtdLinhasGridPrincipal = event.rows;
      this.first = 0;
      this.filtroInterface.numPagina = 0;
      this.filtroInterface.tamanhoPagina = event.rows;
      this.buscarInterfacesAms(true);
    } else {
      if (event.first === 0) {
        this.filtroInterface.numPagina = 0;
        this.filtroInterface.tamanhoPagina = this.qtdLinhasGridPrincipal;
        this.buscarInterfacesAms(false);
      } else if (event.first > 0) {
        this.filtroInterface.numPagina = event.first / event.rows;
        this.filtroInterface.tamanhoPagina = this.qtdLinhasGridPrincipal;
        this.buscarInterfacesAms(false);
      }
    }
    this.ordenarListaInterfaceAms(false);
  }

  async buscarDetalheInterfaceAms(id: number, tamanhoPagina?: number, numPagina?: number) {
    this.idInterfaceSelecionadaDetalhes = id;
    this.submitted = true;
    this.listaInterfaceAmsDetalhes = new Array();
    this.totalRegistrosGridDetalhes = 0;
    this.firstDetalhes = 0;
    await this.consultaService.buscarDetalhesInterfaceAms(this.idInterfaceSelecionadaDetalhes, tamanhoPagina, numPagina).then(data => {
      this.listaInterfaceAmsDetalhes = data.content;
      this.totalRegistrosGridDetalhes = data.totalElements;
      this.interfaceErroDetalhesDialog = true;
    }, (err) => {
      console.log(err);
      this.idInterfaceSelecionadaDetalhes = null;
      this.submitted = false;
      this.messageService.add({
        severity: 'error',
        summary: 'Erro',
        detail: 'Erro Consulta dos detalhes erros',
        life: 3000
      });
    });
    this.submitted = false;
  }

  buscarDetalhesInterfacesAmsPorPagina(event: LazyLoadEvent) {
    if (this.idInterfaceSelecionadaDetalhes != null && this.idInterfaceSelecionadaDetalhes !== undefined) {
      if (this.qtdLinhasGridDetalhes !== event.rows) {
        this.qtdLinhasGridDetalhes = event.rows;
        this.firstDetalhes = 0;
        this.buscarDetalheInterfaceAms(this.idInterfaceSelecionadaDetalhes, this.qtdLinhasGridDetalhes, 0);
      } else {
        if (event.first === 0) {
          this.buscarDetalheInterfaceAms(this.idInterfaceSelecionadaDetalhes, this.qtdLinhasGridDetalhes, 0);
        } else if (event.first > 0) {
          let numPagina = event.first / event.rows;
          this.buscarDetalheInterfaceAms(this.idInterfaceSelecionadaDetalhes, this.qtdLinhasGridDetalhes, numPagina);
        }
      }
    }
  }

  async buscarListaInterfacesArquivo(reset: boolean) {
    this.submitted = true;
    await this.consultaService.buscarListaInterfaceArquivo().then(data => {
      this.listaInterfaceArquivos = data;
    }, (err) => {
      console.log(err);
      this.submitted = false;
      this.messageService.add({
        severity: 'error',
        summary: 'Erro',
        detail: 'Erro carregar lista de Interfaces',
        life: 3000
      });
    });
    this.submitted = false;
  }

  limparFiltro() {
    this.filtroInterface = <FiltroInterface>({
      interfaceArquivo: null,
      tipoMovimento: null,
      situacaoProcessamento: null,
      dataInicio: null,
      dataTermino: null,
    });
  }

  retornaTipoMovimento(tipo: string) {
    if (tipo === 'S') {
      return 'Nova Solução Financeira -> P1'
    } else {
      return 'P1 -> Nova Solução Financeira'
    }
  }

  retornDataGeracao(data: Date) {
    try {
      let dataFormatada = this.datePipe.transform(data, 'dd/MM/yyyy HH:mm');
      return dataFormatada;
    } catch (e) {
      return data;
    }
  }

  retornData(data: Date) {
    try {
      let dataFormatada = this.datePipe.transform(data, 'yyy-MM-dd');
      return dataFormatada;
    } catch (e) {
      return data;
    }
  }

  downloadArquivo() {
    this.getDownloadArquivoOriginal(this.idInterfaceAmsSelecionada);
  }

  gerarRelatorioDetalhado() {
    this.getDownloadArquivoExcel(this.idInterfaceAmsSelecionada);
  }

  gerarExcelConsolidado() {
    this.getDownloadExcelConsolidado(this.idInterfaceAmsSelecionada);
  }

  handleEvent(event: any, _idInterfaceSelecionada, _nomeArquivoSelecionado) {
    this.idInterfaceAmsSelecionada = _idInterfaceSelecionada;
    this.nomeArquivoSelecionado = _nomeArquivoSelecionado.trim().replace('\u0000', '').replace(' ', '').replace(/\0/g, '');
    console.log(`dropdownclicado: Id: ${this.idInterfaceAmsSelecionada}, nome arquivo: ${this.nomeArquivoSelecionado} `);
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }

  getDownloadArquivoOriginal(idInterface: number) {
    this.responseFileDTO = null;
    this.submitted = true;

    const arquivoDownload = this.listaInterfaceAms.filter(intefaceItem => intefaceItem.id === idInterface)
    let qtdeRegistros = 0;
    let qtdeErros = 0;
    let qtdeExcluidos = 0;
    arquivoDownload.map(data => {
      qtdeRegistros = data.qtdeRegistros
      qtdeErros = data.qtdeErros
      qtdeExcluidos = data.qtdeExcluidos
    });

    this.consultaService.checkFile(idInterface)
      .then(data => {
        this.responseFileDTO = data;

        if (this.responseFileDTO != null && this.responseFileDTO.existe) {
          let _nomeArquivo = this.responseFileDTO.containerInterfaces ? this.responseFileDTO.nomeArquivoContainer : this.responseFileDTO.nomeArquivo + '.txt';

          if (qtdeRegistros >= 10000 || qtdeErros >= 10000 || qtdeExcluidos >= 10000) {
            console.log("_nomeArquivo: " + _nomeArquivo)
            this.submitted = false;
            this.consultaService.downloadArquivoOriginalEmail(_nomeArquivo, this.responseFileDTO.containerInterfaces, this.email, this.responseFileDTO.nomeArquivo);
            this.messageService.add({
              severity: "success",
              summary: 'Arquivo Original',
              detail: "Arquivo muito Grande Link para Download enviado por e-mail",
              life: 3000
            });
          } else {
            this.consultaService.getDownloadArquivoStream(_nomeArquivo, this.responseFileDTO.containerInterfaces)
              .then(data => {
                this.consultaService.downLoadFile(data, this.responseFileDTO.nomeArquivo + '.txt')
                this.messageService.add({
                  severity: "success",
                  summary: "Sucesso",
                  detail: "Download concluido",
                  life: 3000
                });
                this.submitted = false;
              }, (err) => {
                this.submitted = false;
                this.messageService.add({
                  severity: "error",
                  detail: "Erro:  Falha ao executar o download do arquivo ",
                  life: 3000
                });
                this.submitted = false;
              })
          }

        } else {
          this.messageService.add({ severity: 'warn', summary: 'Download Arquivo', detail: 'Arquivo não encontrado' });
          this.submitted = false;
        }
      }, (err) => {
        this.messageService.add({ severity: 'error', summary: 'Download Arquivo', detail: 'Arquivo não encontrado' });
        this.submitted = false;
      });

  }

  getDownloadArquivoExcel(idInterface: number) {
    this.responseFileDTO = null;
    this.submitted = true;

    const interfaceDownload = this.listaInterfaceAms.filter(intefaceItem => intefaceItem.id === idInterface);
    let qtdeRegistros = 0;
    let qtdeErros = 0;
    let qtdeExcluidos = 0;
    interfaceDownload.map(data => {
      qtdeRegistros = data.qtdeRegistros
      qtdeErros = data.qtdeErros
      qtdeExcluidos = data.qtdeExcluidos
    });

    this.consultaService.checkFile(idInterface)
      .then(data => {
        this.responseFileDTO = data;

        if (this.responseFileDTO != null && this.responseFileDTO.existe) {

          let _nomeArquivo = this.responseFileDTO.containerInterfaces ? this.responseFileDTO.nomeArquivoContainer : this.responseFileDTO.nomeArquivo;
          let arquivoExcel = this.responseFileDTO.nomeArquivo.toString().replace('.txt', '').replace('.DAT', '').concat('.xlsx');

          if (qtdeRegistros >= 10000 || qtdeErros >= 10000 || qtdeExcluidos >= 10000) {
            this.submitted = false;
            this.messageService.add({ severity: 'success', summary: 'Relatório Detalhado', detail: 'Arquivo muito Grande Link para Download enviado por e-mail', life: 10000 });
            this.consultaService.enviaExcelEmail(idInterface, _nomeArquivo, this.responseFileDTO.containerInterfaces, this.email)
          } else {
            this.consultaService.getDownloadExcel(idInterface, _nomeArquivo, this.responseFileDTO.containerInterfaces)
              .then(data => {
                this.consultaService.downLoadFile(data, arquivoExcel)
                this.messageService.add({
                  severity: "success",
                  summary: "Sucesso",
                  detail: "Relatório concluido",
                  life: 3000
                });
                this.submitted = false;
              }, (err) => {
                this.messageService.add({
                  severity: "error",
                  detail: "Erro:  Falha ao executar o Geração do relatório ",
                  life: 3000
                });
                this.submitted = false;
              })
          }
        } else {
          this.messageService.add({ severity: 'warn', summary: 'Arquivo Original', detail: 'Arquivo não encontrado' });
          this.submitted = false;
        }
      }, (err) => {
        this.messageService.add({ severity: 'error', summary: 'Arquivo Original', detail: 'Arquivo não encontrado' });
        this.submitted = false;
      });
  }

  getDownloadExcelConsolidado(idInterface: number) {
    this.responseFileDTO = null;
    this.submitted = true;
    let arquivoExcel = 'relatorio_consolidado_' + this.nomeArquivoSelecionado + '.xlsx';

    const arquivoDownload = this.listaInterfaceAms.filter(intefaceItem => intefaceItem.id === idInterface)
    let qtdeRegistros = 0;
    let qtdeErros = 0;
    let qtdeExcluidos = 0;

    arquivoDownload.map(data => {
      qtdeRegistros = data.qtdeRegistros
      qtdeErros = data.qtdeErros
      qtdeExcluidos = data.qtdeExcluidos
    });

    this.consultaService.checkFile(idInterface)
      .then(data => {
        this.responseFileDTO = data;

        if (this.responseFileDTO != null && this.responseFileDTO.existe) {

          let _nomeArquivo = this.responseFileDTO.containerInterfaces
            ? this.responseFileDTO.nomeArquivoContainer
            : this.responseFileDTO.nomeArquivo;

          this.consultaService.getDownloadExcelConsolidadoEmTela(idInterface, _nomeArquivo, this.responseFileDTO.containerInterfaces)
            .then(data => {
              this.consultaService.downLoadFile(data, arquivoExcel)
              this.messageService.add({
                severity: "success",
                summary: "Sucesso",
                detail: "Relatório concluido",
                life: 3000
              });
              this.submitted = false;
            }, (err) => {
              this.messageService.add({
                severity: "error",
                detail: "Erro:  Falha ao executar o Geração do relatório ",
                life: 3000
              });
              this.submitted = false;
            })
        } else {
          this.messageService.add({ severity: 'warn', summary: 'Arquivo Original', detail: 'Arquivo não encontrado' });
          this.submitted = false;
        }
      }, (err) => {
        this.messageService.add({
          severity: "error",
          detail: "Erro:  Falha na Geração do relatório ",
          life: 3000
        });
        this.submitted = false;
      });
  }

  async exportarExcel() {
    try {
      import("xlsx").then(xlsx => {
        const worksheet = xlsx.utils.json_to_sheet(this.listaInterfaceAmsDetalhes);
        const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, "export_excel_detalhes");
      });

    } catch (err) {
      console.log(err);
      this.messageService.add({
        severity: 'error',
        summary: 'Erro',
        detail: 'Erro tentativa buscar protocolos',
        life: 3000
      });
    }
  }

  salvarOcorrencia(listaOcorrencia: any) {
    this.submitted = true;
    this.regularizacaoOcorrenciaService.postOcorrencia(listaOcorrencia).subscribe(data => {
      if (data === null) {
        this.submitted = false;
        this.interfaceListaOcorrenciaCadastradaDB2 = false;
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Ocorrencia Salva com Sucesso',
          life: 3000
        });
        this.abrirRegularizacaoOcorrencia();
      }
    }, (err) => {
      this.messageService.add({ severity: 'error', summary: 'Erro', detail: 'Erro ao Salvar Ocorrencia', life: 3000 });
      this.submitted = false;
    });
  }

  abrirRegularizacaoOcorrencia() {
    this.submitted = true;
    this.regularizacaoOcorrenciaService.getOcorrencias(this.idInterfaceAmsSelecionada).then(
      data => {
        this.listaOcorrencia = data;
        if (this.listaOcorrencia.length != 0 || this.listaOcorrencia === null) {
          this.submitted = false;
          this.interfaceTratativaOcorrencia = true;

        } else {
          this.regularizacaoOcorrenciaService.getOcorrenciasDB2(this.idInterfaceAmsSelecionada).then(
            data => {
              this.listaOcorrenciaDb2Grid = data
              if (this.listaOcorrenciaDb2Grid.length === 0) {
                this.submitted = false;
                this.messageService.add({ severity: 'error', summary: 'Erro', detail: 'Nenhuma Ocorrencia Encontrada', life: 3000 });
              } else {
                this.submitted = false;
                this.interfaceOcorrenciaNaocadastrada = true;


              }

            }
          )

        }
      }, (err) => {
        this.messageService.add({ severity: 'error', summary: 'Erro', detail: 'Erro ao Buscar Ocorrencia', life: 3000 });
        this.submitted = false;
      });
  }

  OcorrenciaInterfaces() {
    this.interfaceOcorrenciaNaocadastrada = false;
    this.interfaceListaOcorrenciaCadastradaDB2 = true;
  }

  OcorrenciaInterfaceHistorico(id: number) {
    this.idOcorrenciaSelecionda = id;
    this.interfaceRegularizacaoOcorrenciaHistorico = true;
    this.regularizacaoOcorrenciaService.getHistoricoOcorrencias(id).then(data => {
      this.listaHistoricoGrid = data;
      this.submitted = false;
    }, (err) => {
      this.submitted = false;
      this.messageService.add({ severity: 'error', summary: 'Erro', detail: 'Erro Carregar Histórico de Ocorrências', life: 3000 });
    })
  }

  salvarOcorrenciaHistorico() {
    this.ocorrenciaHistoricoDTO.idOcorrencia = this.idOcorrenciaSelecionda;
    this.ocorrenciaHistoricoDTO.decricaoErro = this.situacaoHistorico.decricaoErro;
    this.ocorrenciaHistoricoDTO.situacao = this.situacaoHistorico.situacao.code;
    this.submitted = true;
    this.regularizacaoOcorrenciaService.postOcorrenciaHistorico(this.ocorrenciaHistoricoDTO).subscribe(data => {
      if (data === null) {
        this.submitted = false;

        this.messageService.add({
          severity: 'success', summary: 'Success', detail: 'Histórico de Ocorrencia Salvo com Sucesso', life: 3000
        });
        this.regularizacaoOcorrenciaService.getOcorrencias(this.idInterfaceAmsSelecionada).then(
          data => {
            this.listaOcorrencia = data;
          }, (err) => {
            this.messageService.add({ severity: 'error', summary: 'Erro', detail: 'Erro ao Buscar Ocorrencia', life: 3000 });
            this.submitted = false;
          });
        this.OcorrenciaInterfaceHistorico(this.idOcorrenciaSelecionda);
        this.ocorrenciaHistoricoDTO.idOcorrencia = null;
        this.ocorrenciaHistoricoDTO.decricaoErro = null;
        this.ocorrenciaHistoricoDTO.situacao = null;
        this.situacaoHistorico.decricaoErro = null;
        this.situacaoHistorico.situacao = null;
      }
    }, (err) => {
      this.messageService.add({ severity: 'error', summary: 'Erro', detail: 'Erro ao Salvar Histórico de Ocorrencia', life: 3000 });
      this.submitted = false;
    });
  }

  validaAcesso() {
    let roles = this.msalService.instance.getAllAccounts()[0].idTokenClaims.roles;
    this.email = this.msalService.instance.getAllAccounts()[0].username;
    let validaRole = roles.includes('OCORRENCIA');
    return validaRole;
  }
}
